import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 100:显示文章类
 */
export default class EventText extends EventBase {
  public FilmParam: FilmClass
  public ExtraParam: ExtraClass

  constructor() {
    super()
    let index = 0
    try {
    } catch (Exception) {}
    this.Parameter = [
      '',
      '',
      '',
      '',
      '0',
      '2',
      '0',
      '1',
      '0',
      '0',
      '0',
      '0',
      '0',
      '0',
      '0',
      '0',
      '',
      '0',
      index + '',
    ]

    this.FilmParam = new FilmClass()
    this.ExtraParam = new ExtraClass()
  }

  public Parameter: Array<string> = new Array()

  /// <summary>
  /// 事件ID
  /// </summary>
  Code = EventID.Text

  // #region 事件相关参数都在这里
  /// <summary>
  /// 角色名称
  /// </summary>
  get RoleName() {
    return this.Parameter?.[0] ?? ''
  }

  set RoleName(value) {
    this.Parameter![0] = value.toString()
  }

  /// <summary>
  /// 角色颜色
  /// </summary>
  get RoleColor() {
    return this.Parameter?.[1] ?? ''
  }
  set RoleColor(value) {
    this.Parameter![1] = value.toString()
  }

  /// <summary>
  /// 文本内容
  /// </summary>
  get Content() {
    return this.Parameter?.[2] ?? ''
  }
  set Content(value) {
    this.Parameter![2] = value.toString()
  }

  /// <summary>
  /// 头像
  /// </summary>
  get Portrait() {
    return this.Parameter?.[3] ?? ''
  }
  set Portrait(value) {
    this.Parameter![3] = value.toString()
  }

  /// <summary>
  /// 头像位置(0左  1，右)
  /// </summary>
  get PortraitPos() {
    return parseInt(this.Parameter?.[4] ?? '')
  }
  set PortraitPos(value) {
    this.Parameter![4] = value.toString()
  }

  /// <summary>
  /// 文本位置
  /// </summary>
  get ContentPos() {
    return parseInt(this.Parameter?.[5] ?? '')
  }
  set ContentPos(value) {
    this.Parameter![5] = value.toString()
  }

  /// <summary>
  /// 语速(0"极快", 1"很快", 5"瞬间")
  /// </summary>
  get TalkSpeed() {
    return parseInt(this.Parameter?.[6] ?? '')
  }
  set TalkSpeed(value) {
    this.Parameter![6] = value.toString()
  }

  /// <summary>
  /// 是否显示对话框
  /// </summary>
  get ShowDialog() {
    return this.Parameter?.[7] === '1'
  }
  set ShowDialog(value) {
    this.Parameter![7] = value ? '1' : '0'
  }

  /// <summary>
  /// 头像来源(2:网盘 所有都为2)
  /// </summary>
  get IsPublicwebdisk() {
    return this.Parameter?.[8] == '2'
  }
  set IsPublicwebdisk(value) {
    this.Parameter![8] = value ? '2' : '1'
  }

  /// <summary>
  /// 长文本模式(1开启 0关闭)
  /// </summary>
  get Alignment() {
    return parseInt(this.Parameter?.[9] ?? '')
  }
  set Alignment(value) {
    this.Parameter![9] = value.toString()
  }
  /// <summary>
  /// 描边大小(0"无", 1"细,1像素", 2"中,3像素", 3"粗,5像素")
  /// </summary>
  get BorderSize() {
    return parseInt(this.Parameter?.[10] ?? '')
  }
  set BorderSize(value) {
    this.Parameter![10] = value.toString()
  }
  /// <summary>
  /// 描边颜色
  /// </summary>
  get BorderColor() {
    return this.Parameter?.[11] ?? ''
  }
  set BorderColor(value) {
    this.Parameter![11] = value.toString()
  }
  /// <summary>
  /// 投影大小(0到5像素)
  /// </summary>
  get ProjectionSize() {
    return parseInt(this.Parameter?.[12] ?? '')
  }
  set ProjectionSize(value) {
    this.Parameter![12] = value.toString()
  }

  /// <summary>
  /// 投影角度(0到360)
  /// </summary>
  get ProjectionAngle() {
    return parseInt(this.Parameter?.[13] ?? '')
  }
  set ProjectionAngle(value) {
    this.Parameter![13] = value.toString()
  }

  /// <summary>
  /// 投影距离(0到5像素)
  /// </summary>
  get ProjectionDistance() {
    return parseInt(this.Parameter?.[14] ?? '')
  }
  set ProjectionDistance(value) {
    this.Parameter![14] = value.toString()
  }

  /// <summary>
  /// 投影颜色(RGB)
  /// </summary>
  get ProjectionColor() {
    return this.Parameter?.[15] ?? ''
  }
  set ProjectionColor(value) {
    this.Parameter![15] = value.toString()
  }

  /// <summary>
  /// 额外内容（0关闭1开启，多项间|分隔，每项间，分隔）
  /// 背景图更换开关，背景图 | 是否自定义XY，X，Y | 强调说话人开关，图层编号，类型 | 双重对话，上或下，点后是否消失|是否更换姓名框，姓名框路径|是否自定义姓名框坐标XY，XY|是否更换对话框显示区域,x,y,w,h
  /// </summary>
  get Extra() {
    this.Parameter![16] = this.ExtraParam.TotalString
    return this.Parameter?.[16] ?? ''
  }
  set Extra(value) {
    this.Parameter[16] = value
    this.ExtraParam.TotalString = value
  }

  /// <summary>
  /// 电影字幕效果 (0关闭1开启，多项间|分隔，每项间，分隔)
  ///	是否开启 |帧数|起始相对位置类型X,Y(0左(上) 1中 2右(下))|终止相对位置类型X,Y(同前)|起始位置X,Y|终点位置X,Y
  /// </summary>
  get FilmEffect() {
    this.Parameter![17] = this.FilmParam.TotalString
    return this.Parameter?.[17] ?? ''
  }
  set FilmEffect(value) {
    this.FilmParam.TotalString = value
  }

  /// <summary>
  /// 显示文本事件在整个工程中的唯一标识号
  /// </summary>
  get Index() {
    let i = 0
    if (this.Parameter!.length >= 19) {
      if (this.Parameter && this.Parameter[18]) i = parseInt(this.Parameter[18])
    }
    return i
  }
  set Index(value) {
    this.Parameter![18] = value.toString()
  }

  // #endregion

  /**
   * 配音文件
  */
  get Voice() {
    return this.Parameter?.[19] ?? ''
  }
  set Voice(value) {
    this.Parameter![19] = value.toString()
  }

  /**
   * 音量
  */
  get Volume() {
    return this.Parameter?.[20] ?? ''
  }
  set Volume(value) {
    this.Parameter![20] = value.toString()
  }

  /**
   * 网盘还是本地 2: 网盘
  */
  get VoiceIsPublicwebdisk() {
    return this.Parameter?.[21] == '2'
  }
  set VoiceIsPublicwebdisk(value) {
    this.Parameter && (this.Parameter[21] = value ? '1' : '2')
  }

  /**
   * 是否淡入
   */
  get IsFade() {
    return this.Parameter[22] === '1'
  }
  set IsFade(val) {
    this.Parameter[22] = val ? '1' : '0'
  }

  /**
   * 淡入时间
   */
  get Time() {
    return parseInt(this.Parameter[23])
  }
  set Time(val) {
    this.Parameter[23] = val.toString()
  }

  /**
   * 时间单位：0 帧，1 秒
   */
  get TimeUnit() {
    return parseInt(this.Parameter[24])
  }
  set TimeUnit(val) {
    this.Parameter[24] = val ? '1' : '0'
  }

  get BkgImagePath(){
    return this.ExtraParam.BkgImagePath
  }

  set BkgImagePath(value:string){
    this.ExtraParam.BkgImagePath = value
  }

  get NameBorderPath(){
    return this.ExtraParam.NameBorderPath
  }

  set NameBorderPath(value:string){
    this.ExtraParam.NameBorderPath = value
  }
}



class ExtraClass {
  public ExtraParams: string[] = []
  public constructor() {
    // this.event = event
    this.ExtraParams = [
      '0',
      '',
      '0',
      '0',
      '0',
      '0',
      '无',
      '0',
      '0',
      '0',
      '0',
      '0',
      '',
      '0',
      '0',
      '0',
      '0',
      '0',
      '0',
      '0',
      '0',
    ]
  }

  fromJSON(obj:any){
    if (obj["ExtraParams"] !== undefined ){
      this.ExtraParams = []
      for(let i = 0; i < obj["ExtraParams"].length; i++){
        this.ExtraParams[i] = obj["ExtraParams"][i]
      }
    }
  }
  /// <summary>
  /// 额外参数总体字符串
  /// </summary>
  get TotalString() {
    return !this.Senior
      ? ''
      : this.ExtraParams[0] +
          ',' +
          this.ExtraParams[1] +
          '|' +
          this.ExtraParams[2] +
          ',' +
          this.ExtraParams[3] +
          ',' +
          this.ExtraParams[4] +
          '|' +
          this.ExtraParams[5] +
          ',' +
          this.ExtraParams[6] +
          ',' +
          this.ExtraParams[7] +
          '|' +
          this.ExtraParams[8] +
          ',' +
          this.ExtraParams[9] +
          ',' +
          this.ExtraParams[10] +
          '|' +
          (this.ExtraParams.length > 11 ? this.ExtraParams[11] : '') +
          ',' +
          (this.ExtraParams.length > 12 ? this.ExtraParams[12] : '') +
          '|' +
          (this.ExtraParams.length > 13 ? this.ExtraParams[13] : '') +
          ',' +
          (this.ExtraParams.length > 14 ? this.ExtraParams[14] : '') +
          ',' +
          (this.ExtraParams.length > 15 ? this.ExtraParams[15] : '') +
          '|' + 
          (this.ExtraParams.length > 16 ? this.ExtraParams[16] : '') + 
          ',' + 
          (this.ExtraParams.length > 17 ? this.ExtraParams[17] : '') + 
          ',' + 
          (this.ExtraParams.length > 18 ? this.ExtraParams[18] : '') + 
          ',' + 
          (this.ExtraParams.length > 19 ? this.ExtraParams[19] : '') + 
          ',' + 
          (this.ExtraParams.length > 20 ? this.ExtraParams[20] : '') 

  }

  /**
   * 高级文本参数
   * @param value
   * @constructor
   */
  set TotalString(value) {
    this.Senior = value != ''
    if (value != '') {
      let pars = value.split('|')

      if (pars != null && pars[0] != '' && pars[0] != '0') {
        for (let i = 0; i < pars.length; i++) {
          let item = pars[i].split(',')
          if (i == 0) {
            this.ExtraParams[0] = item[0]
            this.ExtraParams[1] = item[1]
          } else if (i == 1) {
            this.ExtraParams[2] = item[0]
            this.ExtraParams[3] = item[1]
            this.ExtraParams[4] = item[2]
          } else if (i == 2) {
            this.ExtraParams[5] = item[0]
            this.ExtraParams[6] = item[1]
            if (item.length > 2) {
              this.ExtraParams[7] = item[2]
            } else {
              this.ExtraParams[7] = '0'
            }
          } else if (i == 3) {
            this.ExtraParams[8] = item[0]
            this.ExtraParams[9] = item[1]
            this.ExtraParams[10] = item[2]
          } else if (i == 4) {
            this.ExtraParams[11] = item[0]
            this.ExtraParams[12] = item[1]
          } else if (i == 5) {
            this.ExtraParams[13] = item[0]
            this.ExtraParams[14] = item[1]
            this.ExtraParams[15] = item[2]
          }else if (i == 6) {
            this.ExtraParams[16] = item[0]
            this.ExtraParams[17] = item[1]
            this.ExtraParams[18] = item[2]
            this.ExtraParams[19] = item[3]
            this.ExtraParams[20] = item[4]
          }
        }
      }
    }
  }

  // #region 类的绑定数据的参数都在这里
  public senior = '0'
  /// <summary>
  /// 是否开启高级模式
  /// </summary>
  get Senior() {
    return this.senior == '1'
  }
  set Senior(value) {
    this.senior = value ? '1' : '0'
  }
  /// <summary>
  /// 背景图更换开关
  /// </summary>
  get IsBkgSwitchOn() {
    return this.ExtraParams[0] == '1'
  }
  set IsBkgSwitchOn(value) {
    this.ExtraParams[0] = value ? '1' : '0'
  }
  /// <summary>
  /// 背景图
  /// </summary>
  get BkgImagePath() {
    return this.ExtraParams[1]
  }
  set BkgImagePath(value) {
    this.ExtraParams[1] = value
  }

  // getLocalesBkgImagePath(lang:string):string{
  //   return this.event?.getLocalesRes(this.BkgImagePath, lang) || ""
  // }

  // setLocalesBkgImagePath(lang:string, value:string){
  //   this.event?.setLocalesRes(this.BkgImagePath, lang, value)
  // }
  /// <summary>
  /// 是否自定义XY
  /// </summary>
  get IsCustomXY() {
    return this.ExtraParams[2] == '1'
  }
  set IsCustomXY(value) {
    this.ExtraParams[2] = value ? '1' : '0'
  }
  /// <summary>
  /// X
  /// </summary>
  get X() {
    return parseInt(this.ExtraParams[3])
  }
  set X(value) {
    this.ExtraParams[3] = value.toString()
  }
  /// <summary>
  /// Y
  /// </summary>
  get Y() {
    return parseInt(this.ExtraParams[4])
  }
  set Y(value) {
    this.ExtraParams[4] = value.toString()
  }
  /// <summary>
  /// 强调说话人开关
  /// </summary>
  get IsStressSpeakerOn() {
    return this.ExtraParams[5] == '1'
  }
  set IsStressSpeakerOn(value) {
    this.ExtraParams[5] = value ? '1' : '0'
  }
  /// <summary>
  /// 图层编号
  /// </summary>
  get LayerID() {
    return this.ExtraParams[6] == '无' ? 0 : parseInt(this.ExtraParams[6])
  }
  set LayerID(value) {
    this.ExtraParams[6] = value.toString()
  }
  /// <summary>
  /// 类型
  /// </summary>
  get Type() {
    return parseInt(this.ExtraParams[7])
  }
  set Type(value) {
    this.ExtraParams[7] = value.toString()
  }
  /// <summary>
  /// 双重对话开关
  /// </summary>
  get IsDoubleDialog() {
    return this.ExtraParams[8] == '1'
  }
  set IsDoubleDialog(value) {
    this.ExtraParams[8] = value ? '1' : '0'
  }
  /// <summary>
  /// 上或下
  /// </summary>
  get IsDialogUp() {
    return this.ExtraParams[9] == '0'
  }
  set IsDialogUp(value) {
    this.ExtraParams[9] = value ? '1' : '0'
  }
  /// <summary>
  /// 点后是否消失
  /// </summary>
  get IsDisapperAfterClick() {
    return this.ExtraParams[10] == '1'
  }
  set IsDisapperAfterClick(value) {
    this.ExtraParams[10] = value ? '1' : '0'
  }

  /// <summary>
  /// 是否更换姓名框
  /// </summary>
  get IsResetNameBorder() {
    if (this.ExtraParams != null && this.ExtraParams.length > 11) {
      return this.ExtraParams[11] == '1'
    } else {
      return false
    }
  }
  set IsResetNameBorder(value) {
    if (this.ExtraParams != null && this.ExtraParams.length > 11) {
      this.ExtraParams[11] = value ? '1' : '0'
    }
  }

  /// <summary>
  /// 姓名框路径
  /// </summary>
  get NameBorderPath() {
    return this.ExtraParams[12]
  }
  set NameBorderPath(value) {
    this.ExtraParams[12] = value
  }
  // getLocalesNameBorderPath(lang:string):string{
  //   return this.event?.getLocalesRes(this.NameBorderPath,lang) || ""
  // }

  // setLocalesBkgNameBorderPath(lang:string, value:string){
  //   this.event?.setLocalesRes(this.NameBorderPath,lang,value)
  // }

  /// <summary>
  /// 是否重置姓名框坐标
  /// </summary>
  get IsResetNameBoderCoordinate() {
    return this.ExtraParams[13] == '1'
  }
  set IsResetNameBoderCoordinate(value) {
    this.ExtraParams[13] = value ? '1' : '0'
  }
  /// <summary>
  /// 对话框X坐标
  /// </summary>
  get NameBorderX() {
    return parseInt(this.ExtraParams[14])
  }
  set NameBorderX(value) {
    this.ExtraParams[14] = value.toString()
  }
  /// <summary>
  /// 对话框Y坐标
  /// </summary>
  get NameBorderY() {
    return parseInt(this.ExtraParams[15])
  }
  set NameBorderY(value) {
    this.ExtraParams[15] = value.toString()
  }

  /// <summary>
  /// 是都启动更换对话框显示区域
  /// </summary>
  set ChangeTalkDialogVisible(isShow:boolean){
    this.ExtraParams[16] = isShow ? '1' : '0'
  }

  get ChangeTalkDialogVisible(){
    return this.ExtraParams[16]=='1'
  }

  /// <summary>
  /// 更换后对话框的 x 坐标
  /// </summary>
  get TalkDialogX(){
     return parseInt(this.ExtraParams[17])
  }

  set TalkDialogX(x:number){
      this.ExtraParams[17] = x.toString()
  }

  /// <summary>
  /// 更换后对话框的 y 坐标
  /// </summary>
  get TalkDialogY(){
    return parseInt(this.ExtraParams[18])
 }

 set TalkDialogY(y:number){
     this.ExtraParams[18] = y.toString()
 }

   /// <summary>
  /// 更换后对话框宽度 w
  /// </summary>
  get TalkDialogW(){
    return parseInt(this.ExtraParams[19])
  }

  set TalkDialogW(w:number){
      this.ExtraParams[19] = w.toString()
 }


  /// <summary>
  /// 更换后对话框宽度 h
  /// </summary>
  get TalkDialogH(){
    return parseInt(this.ExtraParams[20])
  }

  set TalkDialogH(h:number){
      this.ExtraParams[20] = h.toString()
 }


  private isnumeric(str: string): boolean {
    const reg = /^[+-]?\d*[.]?\d*$/
    return reg.test(str)
  }

  protected GetPropertyExtraParams(index: number) {
    if (this.ExtraParams.length > index) {
      if (this.isnumeric(this.ExtraParams[index])) {
        return parseInt(this.ExtraParams[index])
      }
    }
    return -1
  }
  protected GetPropertyExtraParamsStr(index: number) {
    if (this.ExtraParams.length > index) {
      return this.ExtraParams[index]
    }
    return ''
  }
  // #endregion
}

/// <summary>
/// 电影字幕类
/// </summary>
class FilmClass {
  // #region INotifyPropertySet接口的实现及相关方法
  /// <summary>
  /// 唤醒事件
  /// </summary>
  // public virtual event PropertyChangedEventHandler PropertyChanged;
  /// <summary>
  /// （数据变更时）设置属性并反向推进绑定
  /// 建议与属性的set方法器共同使用
  /// </summary>
  /// <param name="_input">目标欲操作设置属性对象</param>
  /// <param name="_value">欲赋之值</param>
  /// <param name="_property">属性名称，用于反向唤醒UI</param>
  // protected virtual void SetProperty(ref string _input, string _value, string _property)
  // {
  //     //更新值
  //     _input = _value;
  //     //根据属性名唤醒对应实例
  //     if (PropertyChanged != null)
  //     {
  //         PropertyChanged.Invoke(this, new PropertyChangedEventArgs(_property));
  //     }
  // }
  // #endregion
  public FilmParams: string[]
  constructor() {
    this.FilmParams = ['0', '0', '0', '0', '0', '0', '0', '0', '0', '0']
  }
  fromJSON(obj:any){
    if (obj["FilmParams"] !== undefined ){
      this.FilmParams = []
      for(let i = 0; i < obj["FilmParams"].length; i++){
        this.FilmParams[i] = obj["FilmParams"][i]
      }
    }
  }
  /// <summary>
  /// 总的字符串
  /// </summary>
  get TotalString() {
    return !this.Open
      ? '0|'
      : this.FilmParams[0] +
          '|' +
          this.FilmParams[1] +
          '|' +
          this.FilmParams[2] +
          ',' +
          this.FilmParams[3] +
          '|' +
          this.FilmParams[4] +
          ',' +
          this.FilmParams[5] +
          '|' +
          this.FilmParams[6] +
          ',' +
          this.FilmParams[7] +
          '|' +
          this.FilmParams[8] +
          ',' +
          this.FilmParams[9]
  }
  set TotalString(value) {
    if (value != null && value != '' && value != '0|') {
      let pars = value.split('|')
      if (pars != null && pars.length == 6) {
        this.FilmParams[0] = pars[0]
        this.FilmParams[1] = pars[1]
        let polet = pars[2].split(',')
        this.FilmParams[2] = polet[0]
        this.FilmParams[3] = polet[1]
        polet = pars[3].split(',')
        this.FilmParams[4] = polet[0]
        this.FilmParams[5] = polet[1]
        polet = pars[4].split(',')
        this.FilmParams[6] = polet[0]
        this.FilmParams[7] = polet[1]
        polet = pars[5].split(',')
        this.FilmParams[8] = polet[0]
        this.FilmParams[9] = polet[1]
      }
    }
  }

  // #region 类的绑定数据的参数都在这里
  /// <summary>
  /// 电影字幕效果是否打开
  /// </summary>
  get Open() {
    return this.FilmParams[0] == '1'
  }
  set Open(value) {
    this.FilmParams[0] = value ? '1' : '0'
  }
  /// <summary>
  /// 速度
  /// </summary>
  get Interval() {
    return parseInt(this.FilmParams[1])
  }
  set Interval(value) {
    this.FilmParams[1] = value.toString()
  }
  /// <summary>
  /// 相对起始位置X(0左 1中 2右)
  /// </summary>
  get REStartX() {
    return parseInt(this.FilmParams[2])
  }
  set REStartX(value) {
    this.FilmParams[2] = value.toString()
  }
  /// <summary>
  /// 相对起始位置Y(0上 1中 2右)
  /// </summary>
  get REStartY() {
    return parseInt(this.FilmParams[3])
  }
  set REStartY(value) {
    this.FilmParams[3] = value.toString()
  }
  /// <summary>
  /// 相对终止位置X()
  /// </summary>
  get REEndX() {
    return parseInt(this.FilmParams[4])
  }
  set REEndX(value) {
    this.FilmParams[4] = value.toString()
  }
  /// <summary>
  /// 相对终止位置
  /// </summary>
  get REEndY() {
    return parseInt(this.FilmParams[5])
  }
  set REEndY(value) {
    this.FilmParams[5] = value.toString()
  }
  /// <summary>
  /// 绝对起始位置X
  /// </summary>
  get AbsStartX() {
    return parseInt(this.FilmParams[6])
  }
  set AbsStartX(value) {
    this.FilmParams[6] = value.toString()
  }
  /// <summary>
  /// 绝对起始位置Y
  /// </summary>
  get AbsStartY() {
    return parseInt(this.FilmParams[7])
  }
  set AbsStartY(value) {
    this.FilmParams[7] = value.toString()
  }
  /// <summary>
  /// 绝对终止位置X
  /// </summary>
  get AbsEndX() {
    return parseInt(this.FilmParams[8])
  }
  set AbsEndX(value) {
    this.FilmParams[8] = value.toString()
  }
  /// <summary>
  /// 绝对终止位置Y
  /// </summary>
  get AbsEndY() {
    return parseInt(this.FilmParams[9])
  }
  set AbsEndY(value) {
    this.FilmParams[9] = value.toString()
  }
  // #endregion
}
